import { useEffect, useRef } from "react";
import * as React from "react";
import { PurchaseExpressClickableDiv } from "components/PurchaseExpress";
import { useCurrentUser } from "actions/CurrentUserActions";
import { CurrentUserLoadingState } from "../reducers/CurrentUserReducer";
import { ExpressCheckoutButtonPosition } from "constants/Analytics";
import { useAppLoading } from "components/AppLoading";

const PurchaseExpressQueryParam = (): React.ReactElement => {
  const lastPosition = localStorage.getItem(
    "lastCheckoutPosition"
  ) as ExpressCheckoutButtonPosition;
  const purchaseButtonRef = useRef<HTMLDivElement>(null);
  const { currentUser, currentUserLoadingState } = useCurrentUser();

  // this hook is called in the app header, which appears in the app loading page
  // the hierarchy gets shuffled around a bit as the page loads, which prevents reconciliation
  // from kicking in, leading to states resetting, and the checkout iframe disappearing. Best
  // to wait for the app to load before launching the checkout flow.
  const appLoading = useAppLoading();

  useEffect(() => {
    if (appLoading) {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const launchCheckout = searchParams.get("um") === "1";
    if (
      launchCheckout &&
      currentUserLoadingState === CurrentUserLoadingState.LOADED
    ) {
      if (!currentUser?.hasPremiumAccess) {
        purchaseButtonRef.current?.click();
      }
      localStorage.removeItem("lastCheckoutPosition");
      window.history.pushState({}, document.title, window.location.pathname);
    }
  }, [appLoading, currentUser, purchaseButtonRef, currentUserLoadingState]);

  return (
    <div style={{ display: "none" }}>
      <PurchaseExpressClickableDiv
        ref={purchaseButtonRef}
        position={lastPosition || ExpressCheckoutButtonPosition.PAGE_LOAD}
      >
        <></>
      </PurchaseExpressClickableDiv>
    </div>
  );
};

export default PurchaseExpressQueryParam;
